import React from "react";
import { Link } from "react-router-dom";

import GameMascot from '../components/GameMascot';

export default function Home({setUser}) {
  // Class 4 and 5 are available
  // More classes can be added here in the future
  const classes = [4, 5];
  
  return (
    <div className="min-h-screen">
      <section className="relative text-center py-16 px-4 overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute inset-0 -z-10 opacity-10">
          <div className="absolute top-10 left-10 w-40 h-40 bg-primary rounded-full mix-blend-multiply animate-float"></div>
          <div className="absolute top-20 right-20 w-32 h-32 bg-secondary rounded-full mix-blend-multiply animate-float delay-100"></div>
          <div className="absolute bottom-10 left-1/4 w-36 h-36 bg-accent rounded-full mix-blend-multiply animate-float delay-200"></div>
        </div>

        <div className="max-w-4xl mx-auto relative">
          {/* show guest avatar on front page for visitors */}
          <GameMascot emotion="happy" position="top-right" variant="guest" />
          
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img 
              src="/images/logo/MathVenture_logo.png" 
              alt="MathVenture Logo" 
              className="h-32 w-auto"
            />
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
            Math Adventure
          </h1>
          <p className="text-lg md:text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
            Master mathematics through fun games and interactive quizzes!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto px-4">
          {classes.map(c => (
            <Link 
              key={c}
              to={`/quiz/${c}`} 
              className="floating-card card-glow group p-12 flex flex-col items-center justify-center hover:scale-105 transition-all"
            >
              <div className="text-6xl font-bold text-primary-dark mb-4 group-hover:scale-110 transition-transform">
                Class {c}
              </div>
              <div className="text-xl text-gray-600 group-hover:text-primary transition-colors mb-2">
                Start Your Math Journey
              </div>
              <div className="text-sm text-gray-500">
                {c === 4 ? '20' : '25'} Interactive Questions
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="mt-16 max-w-4xl mx-auto px-6">
        <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">How to Play</h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="card-glow p-6 text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-light/20 flex items-center justify-center">
              <span className="text-2xl">🎯</span>
            </div>
            <h3 className="font-semibold mb-2">Choose Your Level</h3>
            <p className="text-gray-600">Pick your grade and start with fun math challenges</p>
          </div>
          <div className="card-glow p-6 text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-secondary-light/20 flex items-center justify-center">
              <span className="text-2xl">⭐</span>
            </div>
            <h3 className="font-semibold mb-2">Earn Points</h3>
            <p className="text-gray-600">Answer questions correctly to score points and badges</p>
          </div>
          <div className="card-glow p-6 text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-accent-light/20 flex items-center justify-center">
              <span className="text-2xl">🏆</span>
            </div>
            <h3 className="font-semibold mb-2">Compete</h3>
            <p className="text-gray-600">Challenge friends and climb the leaderboard!</p>
          </div>
        </div>
      </section>

      <section className="mt-16 text-center pb-16">
        <Link 
          to="/leaderboard" 
          className="btn-primary inline-flex items-center space-x-2"
        >
          <span>View Leaderboard</span>
          <span className="text-xl">→</span>
        </Link>
      </section>
    </div>
  );
}
